import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd2ed4b6")

_pushScopeId("data-v-cd2ed4b6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("缴费说明")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("待缴费")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("缴费成功")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("缴费失败")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("扣费相关信息")
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_c_table = _resolveComponent("c-table")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "缴费详情",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "700px",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_11, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withId(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        ref: "formRef",
        "label-width": "110px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, null, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.uuid), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "企业编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.enterpriseCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "企业名称：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.companyName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_c_table, {
                style: {"width":"100%"},
                dataSource: _ctx.tableConfig
              }, null, 8, ["dataSource"]),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "初始类型：" }, {
                    default: _withId(() => [
                      (_ctx.form.initialType === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_2, "是"))
                        : _createCommentVNode("", true),
                      (_ctx.form.initialType === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_3, "否"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费状态：" }, {
                    default: _withId(() => [
                      (_ctx.form.state === 0)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            size: "medium",
                            type: "warning"
                          }, {
                            default: _withId(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.state === 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            size: "medium",
                            type: "success"
                          }, {
                            default: _withId(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.state === 2)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 2,
                            size: "medium",
                            type: "danger"
                          }, {
                            default: _withId(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "实缴总金额：" }, {
                    default: _withId(() => [
                      (_ctx.form.payAmount)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.form.payAmount) + "元（" + _toDisplayString(_ctx.digitUppercase(_ctx.form.payAmount)) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "实到总金额：" }, {
                    default: _withId(() => [
                      (_ctx.form.actualMoney || _ctx.form.actualMoney === 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.form.actualMoney) + " 元（" + _toDisplayString(_ctx.digitUppercase(_ctx.form.actualMoney)) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费备注：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.payRemark || '--'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费渠道：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.payChannel[_ctx.form.payChannel]  || '--'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "内部备注：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.internalRemark || '--'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "第三方流水号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.thirdTradeNo || '--'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "缴费时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.payTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "创建时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.createTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "操作人：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.nickname || '--') + " ", 1),
                      (_ctx.form.accountName)
                        ? (_openBlock(), _createBlock("span", _hoisted_9, "(" + _toDisplayString(_ctx.form.accountName) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.fillDeductionRecordList.length !== 0)
                ? (_openBlock(), _createBlock(_component_el_divider, {
                    key: 0,
                    "content-position": "left"
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fillDeductionRecordList, (item, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "扣费编号：" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.deductionUuid), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "实扣费用：" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.fee), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
})